export default "__VITE_ASSET__CPX8qmAg__"